import React, { PureComponent } from 'react'
import { withTheme } from 'styled-components'

import { Label } from 'atoms/Texts'
import { FormSelect, FormNumber } from 'atoms/Inputs'
import { CardContainer } from './styles'
import lo from 'lodash'
import { BLASTING_REPORT, BLASTING_REPORT_GEOMETRY } from 'fixtures/api';
import { getLookup } from 'Redux/actions/LookupActions';
import { toggleIsLoading } from 'Redux/actions/ViewStateActions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

export class Geometri extends PureComponent {

  componentDidMount(){
    this.fetchLookup()
  }

  fetchLookup() {
    const { getLookup, toggleIsLoading } = this.props
    toggleIsLoading(true)
    getLookup(BLASTING_REPORT, BLASTING_REPORT_GEOMETRY)
    toggleIsLoading(false)
  }

  onChangeVal(value, id, field) {
    const { blastingReportData, fnChange } = this.props
    const reportData = lo.cloneDeep(blastingReportData)
    const details = reportData.details
    const pitIndex = details.detailPit.findIndex((pit => pit.id === id));
    details.detailPit[pitIndex]['geometri'][field] = value
    fnChange(details, 'details')
  }

  render() {
    const { theme, pit, lookups, isDisabled, formRefs } = this.props
    const inputConfig = {
      border: theme.mocaGrey,
      rad: '6px',
      width: '100%',
      yxPadding: '9px 12px',
      height: '34px',
    }

    return (
      <div className={'row col-12 mx-0 px-0'}>
        <CardContainer mb={'16px'}>
          <div className={'row col-12 mx-0 px-0'}>
            <Label lineheight={'21px'} size={'14px'} mb={'0px'} color={'#473A94'}>
              Geometri
            </Label>
          </div>
          <div className={'row col-12 mx-0 px-0'}>
            <div className={'col-6 px-0 pr-2'}>
              <Label lineheight={'14px'} size={'12px'}>
                Burden <span style={{color: theme.mocaOrange}}>(M)</span>
              </Label>
              <FormNumber
                placeholder={'Enter burden'}
                isDecimal
                fractionDigits={1}
                mb={'16px'}
                onChangeVal={value => this.onChangeVal(value, pit.id, 'burden')}
                value={pit.geometri.burden}
                disabled={isDisabled}
                ref={(ref) => (formRefs[`burden_${pit.id}`] = ref)}
                {...inputConfig}
              />
            </div>
            <div className={'col-6 px-0 pl-2'}>
              <Label lineheight={'14px'} size={'12px'}>
                Spacing <span style={{color: theme.mocaOrange}}>(M)</span>
              </Label>
              <FormNumber
                placeholder={'Enter spacing'}
                isDecimal
                fractionDigits={1}
                mb={'16px'}
                onChangeVal={value => this.onChangeVal(value, pit.id, 'spacing')}
                value={pit.geometri.spacing}
                disabled={isDisabled}
                ref={(ref) => (formRefs[`spacing_${pit.id}`] = ref)}
                {...inputConfig}
              />
            </div>
          </div>
          <div className={'row col-12 mx-0 px-0'}>
            <div className={'col-6 px-0 pr-2'}>
              <Label lineheight={'14px'} size={'12px'}>
                Depth <span style={{color: theme.mocaOrange}}>(M)</span>
              </Label>
              <FormNumber
                placeholder={'Enter depth'}
                isDecimal
                fractionDigits={1}
                mb={'16px'}
                onChangeVal={value => this.onChangeVal(value, pit.id, 'depth')}
                value={pit.geometri.depth}
                disabled={isDisabled}
                ref={(ref) => (formRefs[`depth_${pit.id}`] = ref)}
                {...inputConfig}
              />
            </div>
            <div className={'col-6 px-0 pl-2'}>
              <Label lineheight={'14px'} size={'12px'}>
                Stemming <span style={{color: theme.mocaOrange}}>(M)</span>
              </Label>
              <FormNumber
                placeholder={'Enter stemming'}
                isDecimal
                fractionDigits={1}
                mb={'16px'}
                onChangeVal={value => this.onChangeVal(value, pit.id, 'stemming')}
                value={pit.geometri.stemming}
                disabled={isDisabled}
                ref={(ref) => (formRefs[`stemming_${pit.id}`] = ref)}
                {...inputConfig}
              />
            </div>
          </div>
          <div className={'row col-12 mx-0 px-0'}>
            <div className={'col-6 px-0 pr-2'}>
              <Label lineheight={'14px'} size={'12px'}>
                Diameter
              </Label>
              <FormSelect
                placeholder={'Select Diameter'}
                onChangeVal={e => this.onChangeVal(e.target.value, pit.id, 'diameter')}
                options={lookups.blastingReportDiameter || []}
                value={pit.geometri.diameter}
                disabled={isDisabled}
                valField={'name'}
                dispField={'name'}
                arrowSize={'16px'}
                ref={(ref) => (formRefs[`diameter_${pit.id}`] = ref)}
                {...inputConfig}
              />
            </div>
            <div className={'col-6 px-0 pl-2'}>
              <Label lineheight={'14px'} size={'12px'}>
                Number of Hole
              </Label>
              <FormNumber
                placeholder={'Enter number of hole'}
                mb={'16px'}
                onChangeVal={value => this.onChangeVal(value, pit.id, 'numOfHole')}
                value={pit.geometri.numOfHole}
                disabled={isDisabled}
                ref={(ref) => (formRefs[`numOfHole_${pit.id}`] = ref)}
                {...inputConfig}
              />
            </div>
          </div>
        </CardContainer>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  let lookups = {}
  if (state.lookups.data && state.lookups.data.BLASTING_REPORT) {
    const blastingReport = state.lookups.data.BLASTING_REPORT
    const blastingReportDiameter = blastingReport.BLASTING_REPORT_GEOMETRY && blastingReport.BLASTING_REPORT_GEOMETRY.find((d) => d.name === 'DIAMETER')
    lookups.blastingReportDiameter = blastingReportDiameter ? blastingReportDiameter.children.map((d) => ({ name: d.nameDisplay })) : []
  }
  return {
    lookups
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      toggleIsLoading,
      getLookup
    },
    dispatch
  )

export default withTheme(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Geometri)
)
